import React from 'react';
import styled from 'styled-components';
import { useGetAllLicensesQuery } from '../services/keyLicenseApi';
import Spinner from '../components/Spinner';
import AuthLayout from '../components/layout/AuthLayout';

const Container = styled.div`
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h2`
  font-size: 24px;
  color: #3e3c3c;
  margin-bottom: 24px;
  font-weight: 500;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
`;

const Th = styled.th`
  text-align: left;
  padding: 12px 16px;
  border-bottom: 2px solid #f1f4f9;
  color: #3e3c3c;
  font-weight: 500;
  font-size: 14px;
`;

const Td = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #f1f4f9;
  color: #3e3c3c;
  font-size: 14px;
`;

const Tr = styled.tr`
  &:hover {
    background-color: #f8f9fa;
  }
`;

const Message = styled.div<{ error?: boolean }>`
  color: ${props => props.error ? '#d80000' : '#666'};
  font-size: 14px;
  padding: 16px;
  text-align: center;
`;

const Status = styled.span<{ active?: boolean }>`
  color: ${props => props.active ? '#2E7D32' : '#d80000'};
  font-weight: 500;
`;

const KeyLicenseList: React.FC = () => {
  const { data, error, isLoading } = useGetAllLicensesQuery({ pagination_required: false});

  if (isLoading) {
    return (
      <AuthLayout title="License Keys">
        <Container>
          <Spinner />
        </Container>
      </AuthLayout>
    );
  }

  if (error) {
    return (
      <AuthLayout title="License Keys">
        <Container>
          <Message error>Failed to load licenses. Please try again later.</Message>
        </Container>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="License Keys">
      <Container>

      {!data?.keyLicenses?.length ? (
        <Message>No licenses found.</Message>
      ) : (
        <Table>
          <thead>
            <tr>
              <Th>Type</Th>
              <Th>License Key</Th>
              <Th>Available / Total</Th>
              <Th>Status</Th>
              <Th>Created</Th>
            </tr>
          </thead>
          <tbody>
            {data.keyLicenses.map((license) => (
              <Tr key={license.id}>
                <Td>{license.key_license}</Td>
                <Td>{license.key_id}</Td>
                <Td>{license.available_count} / {license.count}</Td>
                <Td>
                  <Status active={license.status === 1}>
                    {license.status === 1 ? 'Active' : 'Inactive'}
                  </Status>
                </Td>
                <Td>{new Date(license.createdAt).toLocaleDateString()}</Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      )}
      </Container>
    </AuthLayout>
  );
};

export default KeyLicenseList;
